const useAcfOptions = async(acfKey: string): Promise<object> => {
    const {data: acfOptions} = await useAsyncData(acfKey, () => {
      return queryCollection("siteOptions").where("acfKey", "=", acfKey).first();
    });
  
    return acfOptions?.value?.body || {};
  }
  
export default useAcfOptions;
    